
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"ic-kitchen-pot"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M7 5h10a3 3 0 013 3v11a2 2 0 01-2 2H6a2 2 0 01-2-2V8a3 3 0 013-3zM22 8H2M10 5V4a2 2 0 012-2 2 2 0 012 2v1"}})])])
          )
        }
      }
    